// How a Circle meets, as `circles.format` stores it, and the formats a member
// asks for in `member_circle_preferences.formats`. One list so a preference
// and a Circle compare as plain strings: the Circle request/response schemas,
// the directory filter and the web forms all read it from here. The
// preferences CHECK constraint mirrors it, so changing a format is a
// migration.
import { z } from 'zod';
export const CIRCLE_FORMATS = ['in_person', 'virtual', 'hybrid'];
export const CircleFormatSchema = z.enum(CIRCLE_FORMATS);
const CIRCLE_FORMAT_SET = new Set(CIRCLE_FORMATS);
export function isCircleFormat(value) {
    return CIRCLE_FORMAT_SET.has(value);
}
//# sourceMappingURL=circle-format.js.map